import ArchbishopWilliams from '../../assets/schools/logos/archbishop-williams.jpg';
import ArlingtonCatholic from '../../assets/schools/logos/arlington-catholic.jpeg';
import AustinPrep from '../../assets/schools/logos/austin-prep.png';
import BCHigh from '../../assets/schools/logos/bc-high.jpg';
import BishopFenwick from '../../assets/schools/logos/bishop-fenwick.jpg';
import CardinalSpellman from '../../assets/schools/logos/cardinal-spellman.jpg';
import CathedralHigh from '../../assets/schools/logos/cathedral-high.jpg';
import CatholicMemorial from '../../assets/schools/logos/catholic-memorial.jpg';
import CentralCatholic from '../../assets/schools/logos/central-catholic.jpeg';
import CristoRey from '../../assets/schools/logos/cristo-rey.jpeg';
import Default from '../../assets/schools/logos/default.jpg';
import FontbonneAcademy from '../../assets/schools/logos/fontbonne-academy.jpeg';
import LowellCatholic from '../../assets/schools/logos/lowell-catholic.jpg';
import MaldenCatholic from '../../assets/schools/logos/malden-catholic.jpg';
import Matignon from '../../assets/schools/logos/matignon.jpg';
import MtAlvernia from '../../assets/schools/logos/mt-alvernia.jpg';
import NewtonCountryDay from '../../assets/schools/logos/newton-country-day.jpg';
import NotreDameCristoRey from '../../assets/schools/logos/notre-dame-cristo-rey.jpg';
import NotreDameHingham from '../../assets/schools/logos/notre-dame-hingham.jpg';
import NotreDameTyngsboro from '../../assets/schools/logos/notre-dame-tyngsboro.jpg';
import PopeJohn from '../../assets/schools/logos/pope-john.jpg';
import MaryAcademy from '../../assets/schools/logos/pma.jpg';
import SacredHeart from '../../assets/schools/logos/sacred-heart.jpg';
import StJohnsPrep from '../../assets/schools/logos/st-johns-prep.jpg';
import StJoseph from '../../assets/schools/logos/st-joseph.png';
import StMary from '../../assets/schools/logos/st-marys.jpg';
import StSebas from '../../assets/schools/logos/st-sebas.jpg';
import UrsulineAcademy from '../../assets/schools/logos/ursuline-academy.jpg';
import XaverianBrothers from '../../assets/schools/logos/xaverian-brothers.jpg';
import BellesiniAcademy from "../../assets/schools/logos/bellesiniacademy.jpg";
import BlessedSacramentSchool from "../../assets/schools/logos/BlessedSacramentSchool.png";
import CheverusCatholicSchool from "../../assets/schools/logos/CheverusCatholicSchool.jpg";
import EastBostonCentral from "../../assets/schools/logos/EastBostonCentral.jpg";
import HolyNameParish from "../../assets/schools/logos/HolyNameParish.jpg";
import ImmaculateConceptionLowell from "../../assets/schools/logos/ImmaculateConceptionLowell.png";
import ImmaculateConceptionNewburyport from "../../assets/schools/logos/ImmaculateConceptionNewburyport.png";
import ImmaculateConceptionRevere from "../../assets/schools/logos/ImmaculateConceptionRevere.png";
import JacksonWalnutPark from "../../assets/schools/logos/JacksonWalnutPark.jpg";
import LawrenceCatholicAcademy from "../../assets/schools/logos/LawrenceCatholicAcademy.png";
import MotherCarolineAcademy from "../../assets/schools/logos/MotherCarolineAcademy.png";
import MountAlverniaAcademy from "../../assets/schools/logos/MountAlverniaAcademy.png";
import NativityPreparatorySchool from "../../assets/schools/logos/NativityPreparatorySchool.png";
import NotreDameAcademy from "../../assets/schools/logos/NotreDameAcademy.jpg";
import OurLadysAcademy from "../../assets/schools/logos/OurLadysAcademy.png";
import OurLadyPerpetualHelp from "../../assets/schools/logos/OurLadyPerpetualHelp.jpg";
import OurLadyAssumption from "../../assets/schools/logos/OurLadyAssumption.jpg";
import QuincyCatholicAcademy from "../../assets/schools/logos/QuincyCatholicAcademy.jpg";
import SacredHeartKingston from "../../assets/schools/logos/SacredHeartKingston.png";
import SacredHeartLynn from "../../assets/schools/logos/SacredHeartLynn.png";
import SacredHeartSchoolRoslindale from "../../assets/schools/logos/SacredHeartSchoolRoslindale.png";
import SacredHeartSchoolWeymouth from "../../assets/schools/logos/SacredHeartSchoolWeymouth.jpg";
import SacredHeartSchoolHaverhill from "../../assets/schools/logos/SacredHeartSchoolHaverhill.png";
import SouthBostonCatholicAcademy from "../../assets/schools/logos/SouthBostonCatholicAcademy.jpg";
import SaintAgathaSchool from "../../assets/schools/logos/SaintAgathaSchool.jpg";
import SaintAgnesSchool from "../../assets/schools/logos/SaintAgnesSchool.png";
import SaintAnthonySchool from "../../assets/schools/logos/SaintAnthonySchool.jpg";
import SaintAugustineSchool from "../../assets/schools/logos/SaintAugustineSchool.jpg";
import SaintBenedictElementarySchool from "../../assets/schools/logos/SaintBenedictElementarySchool.png";
import SaintBrendanSchool from "../../assets/schools/logos/SaintBrendanSchool.png";
import SaintBridgetSchoolAbington from "../../assets/schools/logos/SaintBridgetSchoolAbington.jpg";
import SaintBridgetSchoolFramingham from "../../assets/schools/logos/SaintBridgetSchoolFramingham.png";
import SaintCatherineofSienaSchool from "../../assets/schools/logos/SaintCatherineofSienaSchool.jpg";
import SaintColumbkillePartnership from "../../assets/schools/logos/SaintColumbkillePartnership.jpg";
import SaintCharlesElementarySchool from "../../assets/schools/logos/SaintCharlesElementarySchool.png";
import SaintFrancisXavierSchool from "../../assets/schools/logos/SaintFrancisXavierSchool.png";
import StJohnsPreparatorySchool from "../../assets/schools/logos/StJohnsPreparatorySchool.png";
import StJohnPaulCatholicAcademyColumbia from "../../assets/schools/logos/StJohnPaulCatholicAcademyColumbia.png";
import StJohnPaulCatholicAcademyLowerMills from "../../assets/schools/logos/StJohnPaulCatholicAcademyLowerMills.png";
import StJohnPaulCatholicAcademyNeponset from "../../assets/schools/logos/StJohnPaulCatholicAcademyNeponset.png";
import SaintJohntheBaptistSchool from "../../assets/schools/logos/SaintJohntheBaptistSchool.png";
import SaintJohntheEvangelistSchoolWellesley from "../../assets/schools/logos/SaintJohntheEvangelistSchoolWellesley.png";
import SaintJohntheEvangelistSchoolDanvers from "../../assets/schools/logos/SaintJohntheEvangelistSchoolDanvers.jpeg";
import SaintJosephElementarySchoolMedford from "../../assets/schools/logos/SaintJosephElementarySchoolMedford.png";
import SaintJosephElementarySchoolWakefield from "../../assets/schools/logos/SaintJosephElementarySchoolWakefield.png";
import StJosephNeedham from "../../assets/schools/logos/StJosephNeedham.jpg";
import SaintMaryoftheAnnunciationSchool from "../../assets/schools/logos/SaintMaryoftheAnnunciationSchool.jpg";
import SaintMaryoftheAnnunciationSchoolDanvers from "../../assets/schools/logos/SaintMaryoftheAnnunciationSchoolDanvers.jpg";
import SaintMaryoftheAnnunciationSchoolMelrose from "../../assets/schools/logos/SaintMaryoftheAnnunciationSchoolMelrose.png";
import SaintMaryoftheHillsSchool from "../../assets/schools/logos/SaintMaryoftheHillsSchool.jpg";
import StMichaelLowell from "../../assets/schools/logos/StMichaelLowell.jpg";
import StMichaelNorthAndover from "../../assets/schools/logos/StMichaelNorthAndover.jpg";
import SaintMonicaSchool from "../../assets/schools/logos/SaintMonicaSchool.jpg";
import SaintPatrickSchoolLowell from "../../assets/schools/logos/SaintPatrickSchoolLowell.jpg";
import StPatrickStoneham from "../../assets/schools/logos/StPatrickStoneham.png";
import SaintPaulSchool from "../../assets/schools/logos/SaintPaulSchool.jpg";
import SaintPaulsChoirSchool from "../../assets/schools/logos/SaintPaulsChoirSchool.png";
import SaintPeterSchool from "../../assets/schools/logos/SaintPeterSchool.jpg";
import SaintPiusVElementarySchool from "../../assets/schools/logos/SaintPiusVElementarySchool.png";
import SaintRaphaelParishSchool from "../../assets/schools/logos/SaintRaphaelParishSchool.png";
import SaintTheresaCatholicSomerville from "../../assets/schools/logos/SaintTheresaCatholicSomerville.jpg";
import SaintTheresaofAvilaWestRoxbury from "../../assets/schools/logos/SaintTheresaofAvilaWestRoxbury.png";
import SteJeannedArcSchool from "../../assets/schools/logos/SteJeannedArcSchool.jpg";
import TheSaintsAcademy from "../../assets/schools/logos/TheSaintsAcademy.png";
import TrinityCatholicAcademy from "../../assets/schools/logos/TrinityCatholicAcademy.png";

const images = {
  ArchbishopWilliams: ArchbishopWilliams,
  ArlingtonCatholic: ArlingtonCatholic,
  AustinPrep: AustinPrep,
  BCHigh: BCHigh,
  BishopFenwick: BishopFenwick,
  CardinalSpellman: CardinalSpellman,
  CathedralHigh: CathedralHigh,
  CatholicMemorial: CatholicMemorial,
  CentralCatholic: CentralCatholic,
  CristoRey: CristoRey,
  Default: Default,
  FontbonneAcademy: FontbonneAcademy,
  LowellCatholic: LowellCatholic,
  MaldenCatholic: MaldenCatholic,
  Matignon: Matignon,
  MtAlvernia: MtAlvernia,
  NewtonCountryDay: NewtonCountryDay,
  NotreDameCristoRey: NotreDameCristoRey,
  NotreDameHingham: NotreDameHingham,
  NotreDameTyngsboro: NotreDameTyngsboro,
  PopeJohn: PopeJohn,
  MaryAcademy: MaryAcademy,
  SacredHeart: SacredHeart,
  StJohnsPrep: StJohnsPrep,
  StJoseph: StJoseph,
  StMary: StMary,
  StSebas: StSebas,
  UrsulineAcademy: UrsulineAcademy,
  XaverianBrothers: XaverianBrothers,
  BellesiniAcademy: BellesiniAcademy,
  BlessedSacramentSchool: BlessedSacramentSchool,
  CheverusCatholicSchool: CheverusCatholicSchool,
  EastBostonCentral: EastBostonCentral,
  HolyNameParish: HolyNameParish,
  ImmaculateConceptionLowell: ImmaculateConceptionLowell,
  ImmaculateConceptionNewburyport: ImmaculateConceptionNewburyport,
  ImmaculateConceptionRevere: ImmaculateConceptionRevere,
  JacksonWalnutPark: JacksonWalnutPark,
  LawrenceCatholicAcademy: LawrenceCatholicAcademy,
  MotherCarolineAcademy: MotherCarolineAcademy,
  MountAlverniaAcademy: MountAlverniaAcademy,
  NativityPreparatorySchool: NativityPreparatorySchool,
  NotreDameAcademy: NotreDameAcademy,
  OurLadysAcademy: OurLadysAcademy,
  OurLadyPerpetualHelp: OurLadyPerpetualHelp,
  OurLadyAssumption: OurLadyAssumption,
  QuincyCatholicAcademy: QuincyCatholicAcademy,
  SacredHeartKingston: SacredHeartKingston,
  SacredHeartLynn: SacredHeartLynn,
  SacredHeartSchoolRoslindale: SacredHeartSchoolRoslindale,
  SacredHeartSchoolWeymouth: SacredHeartSchoolWeymouth,
  SacredHeartSchoolHaverhill: SacredHeartSchoolHaverhill,
  SouthBostonCatholicAcademy: SouthBostonCatholicAcademy,
  SaintAgathaSchool: SaintAgathaSchool,
  SaintAgnesSchool: SaintAgnesSchool,
  SaintAnthonySchool: SaintAnthonySchool,
  SaintAugustineSchool: SaintAugustineSchool,
  SaintBenedictElementarySchool: SaintBenedictElementarySchool,
  SaintBrendanSchool: SaintBrendanSchool,
  SaintBridgetSchoolAbington: SaintBridgetSchoolAbington,
  SaintBridgetSchoolFramingham: SaintBridgetSchoolFramingham,
  SaintCatherineofSienaSchool: SaintCatherineofSienaSchool,
  SaintColumbkillePartnership: SaintColumbkillePartnership,
  SaintCharlesElementarySchool: SaintCharlesElementarySchool,
  SaintFrancisXavierSchool: SaintFrancisXavierSchool,
  StJohnsPreparatorySchool: StJohnsPreparatorySchool,
  StJohnPaulCatholicAcademyColumbia: StJohnPaulCatholicAcademyColumbia,
  StJohnPaulCatholicAcademyLowerMills: StJohnPaulCatholicAcademyLowerMills,
  StJohnPaulCatholicAcademyNeponset: StJohnPaulCatholicAcademyNeponset,
  SaintJohntheBaptistSchool: SaintJohntheBaptistSchool,
  SaintJohntheEvangelistSchoolWellesley: SaintJohntheEvangelistSchoolWellesley,
  SaintJohntheEvangelistSchoolDanvers: SaintJohntheEvangelistSchoolDanvers,
  SaintJosephElementarySchoolMedford: SaintJosephElementarySchoolMedford,
  SaintJosephElementarySchoolWakefield: SaintJosephElementarySchoolWakefield,
  StJosephNeedham: StJosephNeedham,
  SaintMaryoftheAnnunciationSchool: SaintMaryoftheAnnunciationSchool,
  SaintMaryoftheAnnunciationSchoolDanvers: SaintMaryoftheAnnunciationSchoolDanvers,
  SaintMaryoftheAnnunciationSchoolMelrose: SaintMaryoftheAnnunciationSchoolMelrose,
  SaintMaryoftheHillsSchool: SaintMaryoftheHillsSchool,
  StMichaelLowell: StMichaelLowell,
  StMichaelNorthAndover: StMichaelNorthAndover,
  SaintMonicaSchool: SaintMonicaSchool,
  SaintPatrickSchoolLowell: SaintPatrickSchoolLowell,
  StPatrickStoneham: StPatrickStoneham,
  SaintPaulSchool: SaintPaulSchool,
  SaintPaulsChoirSchool: SaintPaulsChoirSchool,
  SaintPeterSchool: SaintPeterSchool,
  SaintPiusVElementarySchool: SaintPiusVElementarySchool,
  SaintRaphaelParishSchool: SaintRaphaelParishSchool,
  SaintTheresaCatholicSomerville: SaintTheresaCatholicSomerville,
  SaintTheresaofAvilaWestRoxbury: SaintTheresaofAvilaWestRoxbury,
  SteJeannedArcSchool: SteJeannedArcSchool,
  TheSaintsAcademy: TheSaintsAcademy,
  TrinityCatholicAcademy: TrinityCatholicAcademy
};

export default images;



// WEBPACK FOOTER //
// ./src/components/SchoolBand/SchoolLogos.js